module.exports = __webpack_public_path__ + "img/bay-room-4.896772d5.jpg";